<template>
  <div>
    <trial-status-select :value="value" :menu-props="menuProps" @input="$emit('input', $event)" />
    <div v-if="shouldShowNotStartedMessage" class="error--text pb-4">
      Selecting 'Not Started' will remove the recruiting start date
    </div>
  </div>
</template>

<script>
import { TrialStatus } from '@/helpers/trial-helper'
import TrialStatusSelect from '@/components/insights/TrialStatusSelect'

export default {
  components: { TrialStatusSelect },
  props: {
    value: { type: String, default: null },
    menuProps: { type: Object, default: () => {} }
  },
  data() {
    return {
      originalValue: this.value
    }
  },
  computed: {
    hasStatusChanged() {
      return this.originalValue !== this.value
    },
    shouldShowNotStartedMessage() {
      return this.hasStatusChanged && this.value === TrialStatus.NOT_STARTED.value
    }
  }
}
</script>
